<div class="position-reletivediv popup-inner-space border-bottom-grey">
  <div class="betweenheader text-dark">{{ DashbaordName }}</div>

  <div class="text-right flow-right">
    <span class="popuptile-right font_14 data_center" *ngIf="CreatedUser">
      Created By: {{ CreatedUser }}</span
    >
    <img
      src="../../../assets/images/close_icon.svg"
      alt="..."
      class="img-fluid closeicon2 cursor-pointer"
      (click)="Close()"
    />
  </div>
</div>

<div class="position-reletivediv popup-inner-space">
  <form class="width100" [formGroup]="newdashboardform">
    <div class="container-data56 my-1 pb-2">
      <div class="errmsg error-fix">{{ errorMsg }}</div>
      <div class="sucessmsg error-fix">{{ successMsg }}</div>
    </div>
    <div class="row report_btn-1">
      <div class="col-lg-12 d-flex cursor-pointer">
        <div style="margin: auto 0">
          <input
            id="Single Card Per Meter"
            type="radio"
            value="Single Card Per Meter"
            name="CardMeterConfigurationType"
            formControlName="CardMeterConfigurationType"
            (change)="DisplayTextBox('Single')"
          />
          <label class="color_black">Single Card Per Meter</label>
        </div>
        <div class="ml-3" style="margin: auto 0">
          <input
            id="Multiple Card Per Meter"
            type="radio"
            value="Multiple Card Per Meter"
            name="CardMeterConfigurationType"
            formControlName="CardMeterConfigurationType"
            (change)="DisplayTextBox('Multiple')"
          />
          <label class="color_black">Multiple Card Per Meter</label>
        </div>
        <div>
          <span class="error_msg mt-1 ml-2">{{
            displayMessage.CardMeterConfigurationType
          }}</span>
        </div>
      </div>
    </div>
    <!-- <div class="row marginbottom15">
            <div *ngIf="isdisplayNoofRegisterinput" class="margin-top-5 col-lg-3 pr-0">
                <div class="fxg-field padding-space single_card_input">
                    <label style="display:none;" class="Navuser"></label>
                    <input type="text" OnlyNumber
                        class="fxg-field__input-text fxg-field__input--required sessioncamexclude popup-input-width"
                        name="TotalRegister" formControlName="TotalRegister" required="" />
                    <span class="fxg-field__placeholder fxg-field__placeholder12 fxg-field__floating-placeholder"
                        tabindex="-1">No of Registers</span>
                    <div>
                        <p class="error_msg" *ngIf="displayMessage.TotalRegister">{{displayMessage.TotalRegister}}
                        </p>
                    </div>
                </div>
            </div>
        </div> -->
    <div class="row">
      <div class="col-lg-2 mt-1 padding-right-5">
        <div class="fxg-field fxg-field2">
          <mat-form-field style="display: block" title="Site Name">
            <mat-select
              formControlName="SiteId"
              (selectionChange)="OnChangeSite($event)"
            >
              <mat-option value="">(Select Site)</mat-option>
              <mat-option
                MatFormFieldControl="SiteId"
                *ngFor="let lstsite of SiteList"
                [value]="lstsite.CodeValue"
              >
                {{ lstsite.CodeDisplayText }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <span class="error_msg" *ngIf="displayMessage.SiteId">{{
            displayMessage.SiteId
          }}</span>
        </div>
      </div>
      <div class="col-lg-2 mt-1 paddingleftright5">
        <div class="fxg-field fxg-field2">
          <mat-form-field style="display: block" title="Panel Name">
            <mat-select
              formControlName="PanelId"
              (selectionChange)="OnChangePanel($event)"
            >
              <mat-option value="">(Select Location)</mat-option>
              <mat-option
                MatFormFieldControl="PanelId"
                *ngFor="let lstpanel of PanelList"
                [value]="lstpanel.CodeValue"
              >
                {{ lstpanel.CodeDisplayText }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <span class="error_msg" *ngIf="displayMessage.PanelId">{{
            displayMessage.PanelId
          }}</span>
        </div>
      </div>
      <div class="col-lg-2 mt-1 paddingleftright5">
        <div class="fxg-field fxg-field2">
          <mat-form-field style="display: block" title="Meter Name">
            <mat-select
              formControlName="MeterId"
              (selectionChange)="OnChangeEnergymeter($event)"
            >
              <mat-option value="">(Select Meter)</mat-option>
              <mat-option
                MatFormFieldControl="MeterId"
                *ngFor="let lstenergymeter of EnergymeterList"
                [value]="lstenergymeter.CodeValue"
              >
                {{ lstenergymeter.CodeDisplayText }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <span class="error_msg" *ngIf="displayMessage.MeterId">{{
            displayMessage.MeterId
          }}</span>
        </div>
      </div>
      <div class="col-lg-2 mt-1 paddingleftright5">
        <div class="fxg-field fxg-field2">
          <mat-form-field style="display: block" title="Register Name">
            <mat-select formControlName="RegisterDataId">
              <mat-option value="">(Select RegisterName)</mat-option>
              <mat-option
                MatFormFieldControl="RegisterDataId"
                *ngFor="let lstregister of RegisterData"
                value="{{ lstregister.RegisterDataId }}"
              >
                {{ lstregister.RegisterName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <span class="error_msg" *ngIf="displayMessage.RegisterDataId">{{
            displayMessage.RegisterDataId
          }}</span>
        </div>
      </div>
      <div
        class="col-lg-2 mt-1 paddingleftright5"
        *ngIf="!isdisplayNoofRegisterinput"
      >
        <div class="fxg-field fxg-field2">
          <mat-form-field style="display: block" title="Value Type">
            <mat-select formControlName="ValueType">
              <mat-option value="">(Select Value Type)</mat-option>
              <mat-option
                MatFormFieldControl="RegisterDataId"
                *ngFor="let lstvaluetype of ValueTypeList"
                value="{{ lstvaluetype.CodeValue }}"
              >
                {{ lstvaluetype.CodeDisplayName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <span class="error_msg" *ngIf="displayMessage.ValueType">{{
            displayMessage.ValueType
          }}</span>
        </div>
      </div>
      <div
        class="col-lg-2 mt-1 d-flex justify-content-end"
        style="padding-right: 10px"
      >
        <button
          class="btncommon btn-orange"
          id="btnNewdashboardAdd"
          (click)="AddRegisterData()"
        >
          Add
        </button>
      </div>
    </div>
    <div class="company-table tabel-scrolling">
      <div>
        <table class="table table-layout-fixed">
          <thead class="companytable thead-data td-data-main">
            <tr>
              <th class="widt20 font_14 color_black">Site</th>
              <th class="width15 font_14 color_black">Panel</th>
              <th class="width25 font_14 color_black">Meter Name</th>
              <th class="width15 font_14 color_black">Register Name</th>
              <th
                class="width15 font_14 color_black"
                *ngIf="!isdisplayNoofRegisterinput"
              >
                Value Type
              </th>
              <th class="width10 font_14 color_black text-center">Action</th>
            </tr>
          </thead>
        </table>
      </div>
      <div class="table-scroll-newsite1">
        <table class="table table-layout-fixed">
          <tbody clas="table-responsive-sechedule">
            <tr *ngFor="let lstregister of RegisterDataList">
              <td class="width20 font_14 pt-2">
                {{ lstregister.CompSiteName }}
              </td>
              <td class="width15 font_14 pt-2">
                {{ lstregister.CompPanelName }}
              </td>
              <td class="width25 font_14 pt-2">{{ lstregister.MeterName }}</td>
              <td class="width15 font_14 pt-2">
                {{ lstregister.RegisterName }}
              </td>
              <td
                class="width15 font_14 pt-2"
                *ngIf="!isdisplayNoofRegisterinput"
              >
                {{ lstregister.ValueTypeName }}
              </td>
              <td class="width10 font_14 text-center">
                <button
                  class="btncommon-grey btn-border-gray-table"
                  (click)="
                    DeleteRegisterData(
                      lstregister.EnergymeterID,
                      lstregister.RegisterName
                    )
                  "
                >
                  Delete
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </form>
  <div class="company-btn2">
    <button
      class="btncommon width-fix67"
      id="btnNewdashboardSaveAs"
      (click)="OpenDahbaordPopup()"
    >
      Save As
    </button>
    <button
      type="submit"
      id="btnNewdashboardSave"
      class="btncommon btn-orange btn-border-add-company width-fix67 ml-24"
      (click)="SendSaveDashboardData()"
      *ngIf="DashbaordName"
    >
      Save
    </button>
  </div>
</div>
